import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const AccordionItem = ({
  question,
  answer,
  index,
  openIndex,
  setOpenIndex,
}) => {
  const isOpen = openIndex === index;

  const toggleAccordion = (event) => {
    setOpenIndex(isOpen ? -1 : index);
    event.preventDefault();
  };

  return (
    <li className={isOpen ? "active" : ""}>
      <Link className="d-block py-4 px-3 px-md-4" onClick={toggleAccordion}>
        <span className="px-md-2 d-block">{question}</span>
      </Link>
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: isOpen ? "auto" : 0 }}
        transition={{ duration: 0.3 }} // Duration of the transition in seconds
        style={{ overflow: "hidden" }} // Add overflow: hidden
      >
        <div className="accordion-item px-3 px-md-4">
          <small className="font-mono text-uppercase muted d-block px-md-2">
            {answer}
          </small>
        </div>
      </motion.div>
    </li>
  );
};

const Accordion = () => {
  const [openIndex, setOpenIndex] = useState(-1);

  return (
    <ul className="accordion">
      <AccordionItem
        question="What are Brains?"
        answer="Brains on the Based AI network are akin to 'Subnets'. They are their own dedicated decentralized LLM ecosystem where the brain owner has the authority to specify the model, set the fees, and customize their own configurations."
        index={0}
        openIndex={openIndex}
        setOpenIndex={setOpenIndex}
      />
      <AccordionItem
        question="What are Brain Credits?"
        answer="Brain Credits are a standardized mechanism for minting Brains on the Based AI network. A Brain is always redeemable for 1,000 Brain Credits."
        index={1}
        openIndex={openIndex}
        setOpenIndex={setOpenIndex}
      />
      <AccordionItem
        question="How do I get Brain Credits?"
        answer="Brain Credits can be acquired by burning Pepecoin. Using this interface select the following options: Acquire Brains -> Burning -> Input Amount -> Press Burn."
        index={2}
        openIndex={openIndex}
        setOpenIndex={setOpenIndex}
      />
      <AccordionItem
        question="How else can I get a Brain?"
        answer="Brains can also be acquired by staking 100,000 Pepecoin for 90 days, or by purchasing a Brain NFT on the secondary market."
        index={3}
        openIndex={openIndex}
        setOpenIndex={setOpenIndex}
      />
      <AccordionItem
        question="Can I own part of a Brain?"
        answer="Yes, Brain Credits can be pooled with others for fractional brain ownership. When you redeem less than 1,000 Brain Credits, your credits will be pooled with others."
        index={4}
        openIndex={openIndex}
        setOpenIndex={setOpenIndex}
      />
    </ul>
  );
};

export default Accordion;
